import { defineComponent as _defineComponent } from 'vue'
import VSelect from 'vue-select';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SortSelector',
  props: {
  value: {
    type: [String, Object],
    default: '',
  },
  options: {
    type: Array,
    default: () => [],
  },
},
  emits: ['onSelect'],
  setup(__props, { emit }) {

const props = __props;




const onSelect = (selected: string): void => {
  emit('onSelect', selected);
};

return { __sfc: true,props, emit, onSelect, VSelect, AzIcon }
}

})